import createDocumentResource from '../shared/createDocumentResource';

enum AttributeType {
  Date = 'DATE',
  Percent = 'PERCENT',
  String = 'STRING',
}

interface AttributeDef {
  attr: string;
  label: string;
  type: AttributeType;
}

export interface CustomerProfileDef {
  attributes?: AttributeDef[];
}

const customerProfileDefResource = createDocumentResource<CustomerProfileDef>({
  name: 'customerProfileDef',
  endpoint: 'v1/orgs/:orgId/configuration/customer-profile-def',
});

export default customerProfileDefResource;
